var map = {
	"./Background-Alex.png": 21904,
	"./Background-Steve.png": 643,
	"./Colors-Alex.png": 76103,
	"./Colors-Steve.png": 30963,
	"./Folds-Alex.png": 70923,
	"./Folds-Steve.png": 18982,
	"./Labels.png": 84512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65587;